import {
  DialogContent,
  DialogContentProps,
  DialogProps,
  IconButton,
  Dialog as MuiDialog,
} from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { ErrorIcon } from "../Icons"

interface IGiftExchangeDialogProps extends DialogProps {
  width?: string | number
  open: boolean
  onClose: () => void
  dialogContentProps?: DialogContentProps
}

const Dialog = ({
  width = 400,
  open = false,
  children,
  onClose,
  dialogContentProps,
  sx,
  ...rest
}: IGiftExchangeDialogProps) => {
  const onDialogClose = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _event: any,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason === "escapeKeyDown") {
      onClose()
    }
  }

  return (
    <MuiDialog
      sx={{
        "& .MuiPaper-root": {
          width,
          borderRadius: theme.spacing(2),
        },
        ...{ ...sx },
      }}
      disablePortal
      open={open}
      onClose={onDialogClose}
      {...rest}
    >
      <DialogContent
        sx={{ p: 4, ...{ ...dialogContentProps?.sx, position: "relative" } }}
        {...dialogContentProps}
      >
        <IconButton
          onClick={onClose}
          sx={{ top: 10, right: 10, position: "absolute", p: 0 }}
        >
          <ErrorIcon />
        </IconButton>
        {children}
      </DialogContent>
    </MuiDialog>
  )
}

export default Dialog
